/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateInvoice200Response
 */
export interface GenerateInvoice200Response {
    /**
     * 
     * @type {string}
     * @memberof GenerateInvoice200Response
     */
    billId: string;
}

/**
 * Check if a given object implements the GenerateInvoice200Response interface.
 */
export function instanceOfGenerateInvoice200Response(value: object): value is GenerateInvoice200Response {
    if (!('billId' in value) || value['billId'] === undefined) return false;
    return true;
}

export function GenerateInvoice200ResponseFromJSON(json: any): GenerateInvoice200Response {
    return GenerateInvoice200ResponseFromJSONTyped(json, false);
}

export function GenerateInvoice200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateInvoice200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'billId': json['billId'],
    };
}

export function GenerateInvoice200ResponseToJSON(json: any): GenerateInvoice200Response {
    return GenerateInvoice200ResponseToJSONTyped(json, false);
}

export function GenerateInvoice200ResponseToJSONTyped(value?: GenerateInvoice200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billId': value['billId'],
    };
}

